import { render, staticRenderFns } from "./exchangesettings.vue?vue&type=template&id=47ee7678&scoped=true"
import script from "./exchangesettings.vue?vue&type=script&lang=js"
export * from "./exchangesettings.vue?vue&type=script&lang=js"
import style0 from "./exchangesettings.vue?vue&type=style&index=0&id=47ee7678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ee7678",
  null
  
)

export default component.exports